
import { defineComponent } from 'vue';
// import VClamp from 'vue-clamp';
import { mapState } from 'vuex';
import HistoryIcon from '@/components/icons/HistoryIcon.vue';
import NetworkIcon from '@/components/icons/NetworkIcon.vue';
import ProfileIcon from '@/components/icons/ProfileIcon.vue';
import { getArticleListByTypes } from '@/api/apis';
declare const $clamp: any;

export default defineComponent({
  name: 'AboutUsSection',
  components: {
    HistoryIcon,
    NetworkIcon,
    ProfileIcon
    // VClamp
  },
  props: {
    articles: {
      type: Array,
      required: true,
      default: () => []
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang() {
      this.loadData();
    }
  },
  data() {
    return {
      aboutus: null,
      selfLoaded: false
    };
  },
  created() {
    this.loadData();
  },
  updated() {
    const all = Array.from(this.$el.querySelectorAll('.about-us-content'));
    all.forEach(a => {
      $clamp(a, { clamp: 3 });
    });
  },
  methods: {
    // getSummary(summary) {
    //   return $clamp(summary, { clamp: 'auto' });
    // },
    gotoAboutUs() {
      this.$router.push('/about-us');
    },
    async loadData() {
      const res = await getArticleListByTypes({
        types: 4
      });

      if (res.success) {
        const arr = res.result || [];
        this.aboutus = arr[0];
      }

      this.selfLoaded = true;
    }
  }
});
